import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import LoadingScreen from './components/LoadingScreen';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import BookingPage from './pages/BookingPage';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/" element={
              <div className="content-wrapper fade-in">
                <Navbar />
                <HomePage />
              </div>
            } />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
